import styled from '@emotion/styled';
import { Box, Paper, CardContent, LinearProgress, Card, Button } from '@mui/material';
import { alpha } from '@mui/material';
import { colors } from 'Constants/Colors';

export const QuestionnaireWrapper = styled(Box)`
  display: flex;
  height: 100%;
  width: 100%;
  background-color: #fafafa;
  justify-content: center;
  align-items: center;
`;

export const QuestionnaireCard = styled(Card)`
  max-width: 600px;
  height: 700px;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  margin-left: 16px;
  margin-right: 16px;
`;

export const QuestionnaireContainer = styled(Paper)`
  height: 500px;
  max-height: 500px;
  width: 500px;
  margin-top: 40px;
  padding: 30px;
`;

export const QuestionnaireContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const QuestionnaireContent = styled(CardContent)`
  padding-left: 24px;
  padding-right: 24px;
  height: 500px;
  max-height: 500px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 8px;
    background: ${alpha(colors.GREEN, 0.05)};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${alpha(colors.GREEN, 0.2)};
    border-radius: 4px;
    &:hover {
      background: ${alpha(colors.GREEN, 0.3)};
    }
  }
`;

export const QuestionnaireProgress = styled(LinearProgress)`
  height: 6px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${alpha(colors.GREEN, 0.1)};

  .MuiLinearProgress-bar {
    background-color: ${colors.GREEN};
  }
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  height: 50px;
  color: ${colors.GREEN};
  border-radius: 0;
  font-size: 16px;
  &:hover {
    background-color: ${alpha(colors.GREEN, 0.2)};
  }
`;
